import { useEffect, useRef, useState } from "react";

import { useDashboardStore } from "@/stores/useDashboardStore";

import { ApiResources } from "../../../../../api/resources";
import useGetInitialData from "../../../hooks/useGetInitialData";

const useCCexpiration = () => {
  const { getInitialData } = useGetInitialData();

  const {
    ccExpiry: ccExpiryData,
    setCCExpiry,
    setCCExpiryError,
  } = useDashboardStore();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getInitialData({
        setIsLoading,
        setDataState: setCCExpiry,
        resource: ApiResources.DashboardCompanyCardsExpirySummary,
        initialized,
        setError: setCCExpiryError,
      });
    }
  }, [getInitialData, setCCExpiry, setCCExpiryError]);

  return { ccExpiryData, isLoading };
};

export default useCCexpiration;
